import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: '/:channel/groups',
  name: 'Groups',
  component: Layout,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/groups/route.js